// The PR-preview banner's rule and words. The backend decides (`IS_PULL_REQUEST=true` on a
// Render PR preview, see preview_mode.py) and says so on `/api/me`; the page only reports it.

import type { MeResponse } from '../api/types';

export const PREVIEW_BANNER_TEXT = 'PREVIEW · writes off';

// Only an explicit `true` shows the banner: a missing or failed `/api/me` is not a preview.
export function showsPreviewBanner(me: MeResponse | undefined): boolean {
  return me?.preview === true;
}
